// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"g5rT0X","Footer":"y6__zi","Logo":"kHiUBF","Copy":"U6IuKU","Hub":"UQpeEO","Links":"_2B6HbS","White":"KYHPjz","Center":"_9CcdEK","coBrandedLogo":"_0WIVvY","Icone":"z7D1A1"};